import {
  ADD_NOTES,
  ADD_NOTE,
  DELETE_NOTE,
  UPDATE_NOTE,
  FETCHING_NOTES,
  FETCHED_NOTES,
  ADD_PROJECTS,
  ADD_CLINICAL_FINDINGS,
  FETCHING_CLINICAL_FINDINGS,
  FETCHED_CLINICAL_FINDINGS,
  CLEAR_ALL
} from "../actions/constants";
import defaults from "./defaults";

const notesReducer = (state = defaults.notes, { type, payload }) => {
  switch (type) {
    case ADD_NOTES:
      return { ...state, list: { ...state.list, [payload.project_id]: payload.list } };
    case ADD_NOTE:
      const existing_notes_add = (state.list[payload.project_id] || []).filter((p) => p.id !== payload.id);
      return { ...state, list: { ...state.list, [payload.project_id]: [...existing_notes_add, payload] } };
    case UPDATE_NOTE:
      const updating_target_list = state.list[payload.project_id];
      const updating_target = updating_target_list.find((d) => d.id === payload.id);
      const updating_filtered = updating_target_list.filter((d) => d.id !== payload.id);
      const updating_with_updates = { ...updating_target, ...payload };
      return { ...state, updating_note: false, list: { ...state.list, [payload.project_id]: [...updating_filtered, updating_with_updates] } };
    case DELETE_NOTE:
      const current = state.list[payload.project_id];
      const remaining = current.filter((d) => d.id !== payload.id);
      return { ...state, list: { ...state.list, [payload.project_id]: remaining } };
    case FETCHING_NOTES:
      return { ...state, fetching: payload };
    case FETCHED_NOTES:
      return { ...state, fetched: { ...state.fetched, [payload.project_id]: new Date() } };
    case ADD_CLINICAL_FINDINGS:
      return {
        ...state,
        clinicalFindings: { ...state.clinicalFindings, [payload.project_id]: payload.data },
        fetchedClinicalFindings: { ...state.fetchedClinicalFindings, [payload.project_id]: new Date() }
      };
    case FETCHING_CLINICAL_FINDINGS:
      return { ...state, fetchingClinicalFindings: payload };
    case FETCHED_CLINICAL_FINDINGS:
      return { ...state, fetchedClinicalFindings: { ...state.fetchedClinicalFindings, [payload.project_id]: new Date() } };
    case ADD_PROJECTS:
      return { ...state, fetched: {}, fetching: false, list: {} };
    case CLEAR_ALL:
      return defaults.notes;
    default:
      return state;
  }
};

export default notesReducer;